// Anuncios por voz (Web Speech API / speechSynthesis).
// Sustituye los tonos por una voz en espanol que anuncia cada notificacion.
// Prefiere una voz latina (es-419 / es-MX / es-AR / es-VE / ...) y la cachea
// para que sea ESTABLE (siempre la misma voz entre mensajes).

let _voices = [];
let _token = 0;
let _cachedVoice = null;

// Orden de preferencia: acento latinoamericano primero, luego Espana.
const _LATAM_PREF = [
  'es-419', 'es-mx', 'es-ar', 'es-ve', 'es-co', 'es-cl', 'es-pe', 'es-us', 'es-es',
];

function _normLang(lang) {
  return (lang || '').toLowerCase().replace('_', '-');
}

function _initVoices() {
  if (!voiceSupported()) return;
  try {
    _voices = window.speechSynthesis.getVoices() || [];
  } catch {}
}

export function voiceSupported() {
  return typeof window !== 'undefined' && 'speechSynthesis' in window;
}

if (voiceSupported()) {
  _initVoices();
  window.speechSynthesis.onvoiceschanged = () => {
    _initVoices();
    _cachedVoice = null; // re-elegir cuando el navegador carga voces
  };
}

// Elige una voz en espanol latino estable. Cachea el resultado para no cambiar
// de voz entre mensajes (voz "estable").
function _pickVoice() {
  if (_cachedVoice) return _cachedVoice;
  if (!_voices.length) _initVoices();
  const es = _voices
    .map((v) => ({ v, lang: _normLang(v.lang) }))
    .filter((x) => x.lang.startsWith('es'));
  if (!es.length) return null;
  for (const pref of _LATAM_PREF) {
    const exact = es.find((x) => x.lang === pref);
    if (exact) { _cachedVoice = exact.v; return exact.v; }
  }
  // Sin coincidencia exacta: prioriza el acento latino generico (es-419) o el primero.
  const latam = es.find((x) => x.lang.includes('419')) || es[0];
  _cachedVoice = latam.v;
  return latam.v;
}

// Cancela cualquier anuncio en curso (y marca los callbacks previos como obsoletos).
export function stopVoice() {
  _token += 1;
  if (voiceSupported()) {
    try { window.speechSynthesis.cancel(); } catch {}
  }
}

// Habla `texto` `veces` veces (encadenadas, con una pequeña pausa). `onEnd` se llama
// una única vez cuando termina TODA la secuencia (o si no hay soporte/texto).
// Una nueva llamada cancela la secuencia anterior.
export function speakRepeated(texto, veces = 1, onEnd) {
  if (voiceSupported()) {
    try { window.speechSynthesis.cancel(); } catch {}
  }
  const myToken = ++_token;
  if (!voiceSupported() || !texto) {
    if (typeof onEnd === 'function') onEnd();
    return;
  }
  let restantes = Math.max(1, Math.floor(veces || 1));
  const voz = _pickVoice();
  const hablar = () => {
    if (myToken !== _token) return; // secuencia superada por otra
    const u = new SpeechSynthesisUtterance(texto);
    if (voz) { u.voice = voz; u.lang = voz.lang; }
    else { u.lang = 'es-419'; }
    u.rate = 0.98;   // ritmo estable y natural
    u.pitch = 1.0;
    u.volume = 1.0;
    restantes -= 1;
    u.onend = () => {
      if (myToken !== _token) return;
      if (restantes > 0) {
        setTimeout(hablar, 350);
      } else if (typeof onEnd === 'function') {
        onEnd();
      }
    };
    u.onerror = () => {
      if (myToken !== _token) return;
      if (typeof onEnd === 'function') onEnd();
    };
    try { window.speechSynthesis.speak(u); } catch {}
  };
  hablar();
}
